:host {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;

    label {
        color: var(--solid-ui-color-gray-600);
        font-size: var(--solid-ui-font-size-sm);
        font-weight: 400;
    }

    .input-wrapper {
        position: relative;
        width: 100%;

        input {
            border: 1px solid var(--solid-ui-color-gray-400);
            border-radius: 5px;
            padding: 10px;
            width: 100%;
            background: white;
            color: var(--solid-ui-color-gray-700);
            font-size: inherit;
        }

        input:read-only {
            border: none;
            padding: 0;
            cursor: not-allowed;
        }
    }
    
}
